import createCrudVuexModule from "@/store/crud";

export const unit = createCrudVuexModule({
  namespaced: true,
  path: "/library/unit",
  moduleName: `unit`,
});

export const workspaceUnit = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/unit",
});

export const managementUnit = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/unit",
});
